import { render } from "./ScorChart.vue?vue&type=template&id=019c972e&scoped=true"
import script from "./ScorChart.vue?vue&type=script&lang=js"
export * from "./ScorChart.vue?vue&type=script&lang=js"

import "./ScorChart.vue?vue&type=style&index=0&id=019c972e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-019c972e"]])

export default __exports__